<template>
  <div class="wrapper" id="page-wrapper">
  <div class="container-fluid" id="content" tabindex="-1">
    <div class="row row-entry-content">
      <div class="col-md-48 content-area entry-content" id="primary">


    <h1 class="d-none">Category {{catTitle}}{{filteredItems.length}}</h1>
<div  v-if="filterProducts.length > 0" class="container my-7">
  <div class="row">
    <div class="col-48 gx-5">
      <div class="row d-flex flex-row justify-content-between align-items-center">
        <div class="col-auto d-flex flex-row align-items-center justify-content-start border-bottom border-green border-2 mb-lg-0 mb-5">
          
          <input v-model="name"  id="search-input" type="text" class="form-control bg-transparent  border-0 p-0" placeholder="Filter by Keyword" aria-label="Username" aria-describedby="basic-addon1">
          <span class="input-group-text border-0 bg-transparent p-0 text-green fs-5 fw-bolder" aria-describedby="inputGroup-sizing-lg" id="basic-addon1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-search">
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg></span>
        </div>

        <div class="optionFilter d-flex flex-row align-items-center justify-content-start col-auto">
          <label for="basic-url" class="form-label mb-0 fw-bolder text-green">Filter by Option</label>
<div class="form-check form-check-inline">
          <input type="radio" class="gb-input btn-check" name="options" id="option1" autocomplete="off">
          <label class="btn gb-input-btn fw-bolder px-0 mx-3 rounded-0" for="option1">Offers Outreach</label></div>
<div class="form-check form-check-inline">
          <input type="radio" class="gb-input btn-check" name="options" id="option2" autocomplete="off" checked>
          <label class="btn gb-input-btn fw-bolder px-0 mx-3 rounded-0" for="option2">Out of Hours</label></div>

<div class="form-check form-check-inline">
          <input type="radio" class="gb-input btn-check" name="options" id="option4" autocomplete="off">
          <label class="btn gb-input-btn fw-bolder px-0 mx-3 rounded-0" for="option4">WANADA Certified</label></div>
        </div>



        <div class="sortFilter d-flex flex-row align-items-center justify-content-start col-auto">
          <label for="basic-url" class="form-label mb-0 fw-bolder">Sort by</label>
          <button class="border-0 bg-transparent dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
</svg>Dropdown</button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="#">Nearest to me</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</div>



<div class="container">
  <div class="row">
    <div  id="showresults" class="col-lg-24 col-48 gx-5">
    <div class="col-48">
       <h1 class="d-none">number {{filterProducts.length}}</h1>
      
        <div @click="say({lat:Number(service.newlat),lng: Number(service.newlng )})" v-for="service in filterProducts" :key="service.id" class="side-list" >
            

<div pageId="{{service.id}}"  class="row mb-5"><div class="card text-left border-0 green-card-bg rounded-0  ">

<div class="card-header bg-transparent border-0 p-0 d-flex align-items-center justify-content-end flex-row">
          <div class="openClosed float-right bg-green text-white px-xl-5 px-3 py-3 fw-bolder"> open</div>
          </div>
        <div class="card-body px-5 py-0 text-start">
        <h4 class="card-title fw-bolder">{{service.title}}</h4>
          <p class="card-text fs-5 fw-light">{{service.servicePreview}}</p>
            <div class="cat-svg d-none " v-for="category in service.categories" :key="category">
              {{category}}
          </div>
          </div>
        <div class="card-footer bg-transparent border-0  d-flex align-items-center justify-content-end flex-row p-3">
           <router-link  class="text-decoration-none text-center d-flex flex-row align-items-center justify-content-start p-3 text-green fw-bold viewBtn" :to="{name: 'SingleService', params: { title: service.slug }, props: { services: services } }">
             <span class="me-2">View Service</span>

             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="ico ico-arrow-right">
    <polygon points="6.525 1.355 12.151 6.93 0 6.93 0 9.053 12.151 9.053 6.525 14.645 9.354 14.645 16 8 9.354 1.355 6.525 1.355" fill="currentColor"></polygon>
    </svg>
          </router-link>
          </div>


</div></div>

                  </div>
          
              </div>
    </div>
    <div class="col-lg-24 col-48 gx-5 serviceMap position-relative">
     <GMapMap ref="mapRef"
      :center="center"
      :zoom="zoom"
      :options="mapStyle"

  >
   <GMapInfoWindow
        :options="infoOptions " :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"
      >
        <div class="info-window">
                        <p class="mb-0"><b>{{infoContent.name}}</b></p>
                        <p class="mb-0">Phone: {{infoContent.phone}}</p>
                        <a :href="`https://maps.google.com/maps?daddr=${infoContent.address}`">Get Directions</a>
                      </div>
      </GMapInfoWindow>
    <GMapCluster :zoomOnClick="true">
      <GMapMarker
        :key="index"
        v-for="(m, index) in filterProducts"
        :position="{lat:Number(m.newlat),lng: Number(m.newlng )}"
        :clickable="true"
        :draggable="false"
        @click="toggleInfoWindow(m,index)" 
        :styles="clusterIcon"
      />


        </GMapCluster>


  </GMapMap>
  
    </div>
  </div>
</div>

<div class="container">
  <div class="row py-7">
    <div  id="showresults" class="col-24 gx-5">
    <div class="col-48">
       <h1 class="d-none">number {{singleItem.length}}</h1>
        <div v-for="service in singleItem" :key="service.id" class="side-list">
            

<div pageId="{{service.id}}" class="row mb-5"><div class="card text-left border-0 rounded-0  ">

<div class="card-header bg-transparent border-0 p-0 d-flex align-items-center justify-content-end flex-row">
          <div class="openClosed float-right bg-green text-white px-lg-5 px-3 py-3 fw-bolder"> </div>
          </div>
        <div class="card-body px-5 py-0 text-start">
        <h4 class="card-title fw-bolder">{{service.title}}</h4>
          <p class="card-text fs-5 fw-light">{{service.servicePreview}}</p>
            <div class="cat-svg d-none" v-for="category in service.categories" :key="category">
              {{category}}
          </div>
          <h4 class="text-green">Services Provided:</h4>
          <p>The village program offers;</p>
          <ul class="mb-5">
            <li>Free individual or family counselling sessions</li>
            <li>Information and support on drug and/or alcohol treatment options </li>
            <li>Negotiated locations including home visits where appropriate
</li>
          </ul>
           <h4 class="text-green">Target Groups</h4>
                     <ul class="mb-5">
            <li>Women with drug and alcohol issues who have children under 12 years </li>
            <li>Women who are pregnant and want to change their use of drugs/ alcohol</li>
          </ul>
                     <h4 class="text-green">Entry Requirements</h4>
                     <ul class="mb-5">
            <li>Agencies wishing to refer clients are required to call for a referral form sent via email.</li>
            <li>Women wishing to make an appointment or speak directly to the counsellor in this service should call 9300 1566 Tuesday or Friday</li>
          </ul>
          </div>
        <div class="card-footer bg-transparent border-0  d-flex align-items-center justify-content-end flex-row p-3">
           <router-link  class="text-decoration-none text-center d-flex flex-column align-items-center justify-content-start p-5 text-green fw-bold" :to="{name: 'Home'}">
             Back to Search
          </router-link>
          </div>


</div></div>

                  </div>
          
              </div>
    </div>
    <div class="col-24 gx-5 singleMap">
     <GMapMap
      :center="center"
      :zoom="7"
      :options="mapStyle"
  >
    <GMapCluster :zoomOnClick="true">
          
      <GMapMarker
        :key="index"
        v-for="(m, index) in singleItem"
        :position="{lat:Number(m.newlat),lng: Number(m.newlng )}"
        :clickable="true"
        :draggable="true"
       
        @click="toggleInfoWindow(m,index)"
        :id="m.id"
        ref="marker"
      >
            <GMapInfoWindow
        :opened="true"
      >
       
      </GMapInfoWindow>
    </GMapMarker>
        </GMapCluster>


  </GMapMap>
  
  <div class="row mt-5" v-for="service in singleItem" :key="service.id">
    <div class="col-24">
        <h4 class="text-green text-start">Target Groups</h4>
                            <ul class="mb-5 list-unstyled text-start">
            <li>Phone - {{service.telephone}}</li>
            <li>Email - {{service.email}}</li>
            <li>Website - {{service.website}}</li>
          </ul>
    </div>
       <div class="col-24">
        <h4 class="text-green text-start">Opening Hours: 
</h4>
  <div class="open text-start"  v-for="item in service.items" :key="item.id">
    <span v-if="item.start">{{item.day}} - {{item.start}}am-{{item.end}}pm</span>
  </div>
    </div>
  </div>
    </div>
  </div>
</div>


</div>

</div>
    </div>
</div>
</template>

<script>
import image from "@/assets/m1.png"
export default {
 name: 'Category',
 props: ['services'],
data(){
    return {
      newLat:'',
      newLng:'',
      searchValue: '',
      clusterIcon:[],
      catTitle: '',
      sortDirection: '',
      sortBy: 'name',
      markers: [],
       zoom: 14,
      infoContent: {},
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      positionCalc:'',
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
         center: {lat: -31.92998972353236, lng: 115.85853883219353},
         mapStyle: {
         draggable:true,
           zoomControl: false,
           mapTypeControl: false,
           scaleControl: false,
           streetViewControl: false,
           rotateControl: false,
           fullscreenControl: false,
           animation: 2,
           disableDefaultUI: true,
           styles: [{featureType: "water",elementType: "geometry",stylers: [{color: "#e9e9e9"},{lightness: 17 } ] }, { featureType: "landscape", elementType: "geometry", stylers: [ { color: "#f5f5f5" }, { lightness: 20 } ] }, { featureType: "road.highway", elementType: "geometry.fill", stylers: [ { color: "#ffffff" }, { lightness: 17 } ] }, { featureType: "road.highway", elementType: "geometry.stroke", stylers: [ { color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 } ] }, { featureType: "road.arterial", elementType: "geometry", stylers: [ { color: "#ffffff" }, { lightness: 18 } ] }, { featureType: "road.local", elementType: "geometry", stylers: [ { color: "#ffffff" }, { lightness: 16 } ] }, { featureType: "poi", elementType: "geometry", stylers: [ { color: "#f5f5f5" }, { lightness: 21 } ] }, { featureType: "poi.park", elementType: "geometry", stylers: [ { color: "#dedede" }, { lightness: 21 } ] }, { elementType: "labels.text.stroke", stylers: [ { visibility: "on" }, { color: "#ffffff" }, { lightness: 16 } ] }, { elementType: "labels.text.fill", stylers: [ { saturation: 36 }, { color: "#333333" }, { lightness: 40 } ] }, { elementType: "labels.icon", stylers: [ { visibility: "off" } ] }, { featureType: "transit", elementType: "geometry", stylers: [ { color: "#f2f2f2" }, { lightness: 19 } ] }, { featureType: "administrative", elementType: "geometry.fill", stylers: [ { color: "#fefefe" }, { lightness: 20 } ] }, { featureType: "administrative", elementType: "geometry.stroke", stylers: [ { color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 } ] } ]        
      },
                  pategory: '',
            name: '',
            range: '1000',
            fService: []
      }
    },
     mounted () {


 this.$nextTick(function () {
    var string = this.$route.params.org;
    const catTitle = string.split("-").join(" ");
    this.catTitle = catTitle
  })
   },

    computed: {
    filteredItems: function() {
    return this.services.filter(service => {
          return (service.catSlug.includes(this.$route.params.org))
        }).sort((p1,p2) => {
                    let modifier = 1;
                    if(this.sortDirection === 'desc') modifier = -1;
                    if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier; if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                    return 0;
                });       
     
    },  
    
     filterProducts: function(){
                return this.filterProductsByName(this.filteredItems)
            }
    ,
       singleItem: function(){
          return this.services.filter(service => {
             return (service.slug.includes(this.$route.params.org))
              })
       }
      },

   
        
        methods: {

           filterProductsByName: function() {
                return this.filteredItems.filter((service) => {
                 return service.title.toLowerCase().match(this.name);
                 });
           
           },
         toggleInfoWindow ( service, idx ) {
           console.log('clicked');
         this.infoWindowPos = {lat:Number(service.newlat),lng: Number(service.newlng )},
          this.infoContent = {name: service.title,
                  phone: service.telephone,
                  address: service.address}
          if ( this.currentMidx === idx ) {
            this.infoWinOpen = !this.infoWinOpen
          }
          else {
            this.infoWinOpen = true
            this.currentMidx = idx
          }
        },


    say(service) {
     this.$refs.mapRef.$mapPromise.then((map) => {
      this.zoom = 16;
        map.panTo(service)
            this.infoWinOpen = true
    })

  }

        },

      

   created() {
     //console.log('catalive')
      if(this.$route.query.lat) {
                this.newLat = this.$route.query.lat;
                //console.log(this.newLat);
            };
             if(this.$route.query.lng) {
                this.newLng = this.$route.query.lng;
                //console.log(this.newLng);
                this.center = ( {lat:Number(this.$route.query.lat),lng: Number(this.$route.query.lng)} );
                this.zoom = 14;
            }
    },

}
</script>

<style>

</style>
